<template>
  <div class="w-full">
    <div class="flex justify-center">
      <XTab
        v-if="tabItems.length > 1"
        v-model="currentIndex"
        :items="tabItems"
        class="media-tabs"
        @tab-click="goTo"
      />
    </div>
    <Carousel
      ref="carousel"
      class="rounded-[12px] overflow-hidden sm:p-4 mt-[40px]"
      :autoplay="false"
      @afterChange="onChange"
    >
      <VideoItem
        v-for="item in character?.preview_videos_detail"
        :key="item.video_url"
        :item="item"
        :character="character!"
      />
    </Carousel>
  </div>
</template>
<script lang="ts" setup>
import type { Character } from '~/api/interface/character';
import XTab from '~/design/atom/tab.vue';
import VideoItem from './videoItem.vue';

const props = defineProps<{
  character?: Character;
}>();

const carousel = ref();
const currentIndex = ref(0);
function onChange(index: number) {
  currentIndex.value = index;
}

function goTo(index: number) {
  currentIndex.value = index;
  carousel.value?.goTo(index);
}

const tabItems = computed(() =>
  (props.character?.preview_videos_detail ?? []).map(item => ({
    title: item.text,
    id: item.video_url,
  })),
);
</script>
<style lang="scss" scoped>
.media-tabs {
}
</style>
